module.exports = __webpack_public_path__ + "static/img/social.6b5a1a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/social.png
// module id = hMaq
// module chunks = 18